import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import BasicTab from "./Tabs/BasicTab";
import NafeesTab from "./Tabs/NafeesTab";
import LocationsTab from "./Tabs/LocationsTab";
import InstructorTab from "./Tabs/InstructorTab";
import {
  countryConstants,
  nationalityConstants,
  translationConstants,
} from "../../../constants";
import {
  authActions,
  centerActions,
  SpotActions,
  SubscriptionActions,
} from "../../../redux/actions";
import { convertObjectToFormData, logFormData } from "../../../system";
import { ToastifyService } from "../../../services";

const CenterRegistrationPage = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [nafeesApproved, setNafeesApproved] = useState();
  const [activeTab, setActiveTab] = useState(translationConstants.general);

  const formState = useSelector((state) => state.centerReducer.formState);

  useEffect(() => {
    dispatch(authActions.fetchCities(countryConstants.SAUDIA_ARABIA));
    const body = {
      length: null,
    };
    dispatch(SpotActions.GetAllPublicSpots(body));
    dispatch(
      SubscriptionActions.GetAllSubscriptionPrices({ isLoading: false })
    );
    // eslint-disable-next-line
  }, []);

  const onFormSubmission = (data) => {
    let dataToSend = {
      ...formState,
      ...data,
      userInfo: {
        ...formState.userInfo,
        nationality: nationalityConstants.SAUDIA_ARABIA,
        countryId: countryConstants.SAUDIA_ARABIA,
        documents: formState.userInfo.documents[0],
        phoneNumber: formState.userInfo.phoneNumber,
      },
      logo: formState.logo[0],
      centerInfo: { ...formState.centerInfo },
      spots: formState.spots?.map((spot) => ({
        ...spot,
        safetyDocuments:
          spot.safetyDocuments?.length > 0
            ? spot.safetyDocuments[0]
            : undefined,
        operationalDocuments:
          spot.operationalDocuments?.length > 0
            ? spot.operationalDocuments[0]
            : undefined,
      })),
    };
    var formData = convertObjectToFormData(dataToSend);
    dispatch(
      centerActions.registerCenter(
        formData,
        navigate,
        props.handleShowRegSuccessModal
      )
    );
  };

  return (
    <>
      <Container className="d-flex justify-content-center align-items-center flex-column">
        <p className="welcomeSaudiPara text-center">
          {t(translationConstants.welcomePara)}
        </p>
        <p className="createAccountPara text-center mt-3">
          {t(translationConstants.CREATE_CENTER_ACCOUNT)}
        </p>
      </Container>
      {nafeesApproved === translationConstants.YES ? (
        <Container className="d-flex justify-content-center align-items-center flex-column">
          <Row className="w-100">
            <Col className="d-flex justify-content-center align-items-center flex-column mt-3 center-registration-base-form">
              <Tabs
                activeKey={activeTab}
                className="mr-0 center-registration-tabs"
                onSelect={(k) => setActiveTab(k)}
              >
                <Tab
                  disabled
                  eventKey={translationConstants.general}
                  title={t(translationConstants.general)}
                >
                  {activeTab === translationConstants.general && (
                    <BasicTab
                      goBack={() => setNafeesApproved(undefined)}
                      onNext={() =>
                        setActiveTab(translationConstants.LOCATIONS)
                      }
                    />
                  )}
                </Tab>
                <Tab
                  disabled
                  eventKey={translationConstants.LOCATIONS}
                  title={t(translationConstants.LOCATIONS)}
                >
                  {activeTab === translationConstants.LOCATIONS && (
                    <LocationsTab
                      goBack={() => setActiveTab(translationConstants.general)}
                      onNext={() =>
                        setActiveTab(translationConstants.INSTRUCTOR)
                      }
                    />
                  )}
                </Tab>
                <Tab
                  disabled
                  eventKey={translationConstants.INSTRUCTOR}
                  title={t(translationConstants.INSTRUCTOR)}
                >
                  {activeTab === translationConstants.INSTRUCTOR && (
                    <InstructorTab
                      goBack={() =>
                        setActiveTab(translationConstants.LOCATIONS)
                      }
                      onSubmit={onFormSubmission}
                    />
                  )}
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </Container>
      ) : (
        <NafeesTab
          nafeesApproved={nafeesApproved}
          setNafeesApproved={setNafeesApproved}
        />
      )}
    </>
  );
};

export default CenterRegistrationPage;
